import { cn } from '$components'
import { Fragment, memo } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { COLUMN_OFFSET } from '$features/calendar/constants'
import { ScheduledPerson } from '$features/calendar/hooks/use-calendar-slots'

type CalendarHeaderProps = {
  days: Dayjs[]
  people: ScheduledPerson[]
  isLoading: boolean
}

export const CalendarHeader = memo(function CalendarHeader({
  days,
  people,
  isLoading,
}: CalendarHeaderProps) {
  const today = dayjs.utc()
  const hasPeople = people.length > 0

  return (
    <Fragment>
      {days.map((day, dayIndex) => {
        const isToday = day.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')

        if (hasPeople) {
          const startColumn = (dayIndex * people.length) + COLUMN_OFFSET
          return (
            <div
              key={`day-group-${dayIndex}`}
              className="contents"
            >
              {people.map((person, personIndex) => (
                <div
                  key={`person-${dayIndex}-${personIndex}`}
                  style={{
                    gridColumnStart: startColumn + personIndex,
                    gridRowStart: 1,
                  }}
                  className={cn(
                    'sticky top-0 z-30 bg-gray-50 flex flex-col items-center justify-center h-12 text-xs font-normal text-gray-700 border-b border-r border-gray-100',
                    {
                      'bg-gray-100': isToday,
                      'border-r': personIndex === people.length - 1 && dayIndex < days.length - 1,
                    },
                  )}
                >
                  {isLoading ? (
                    <div className="h-5 w-24 rounded-md animate-pulse bg-gray-100"/>
                  ) : (
                    <>
                      <span className="font-medium py-1">{day.format('D ddd')}</span>
                      <span className="text-gray-700 truncate max-w-full px-1 h-6 py-1">{person.first_name} {person.last_name}</span>
                    </>
                  )}
                </div>
              ))}
            </div>
          )
        } else {
          return (
            <div
              key={dayIndex}
              style={{ gridColumnStart: dayIndex + COLUMN_OFFSET, gridRowStart: 1 }}
              className={cn(
                'sticky top-0 z-30 bg-gray-50 flex items-center justify-center h-12 text-xs font-medium text-gray-700 border-b border-r border-gray-100',
                { 'bg-gray-100': isToday },
              )}
            >
              {isLoading
                ? <div className="h-5 w-24 rounded-md animate-pulse bg-gray-100"/>
                : <p>{day.format('D ddd')}</p>
              }
            </div>
          )
        }
      })}
    </Fragment>
  )
})